import { render, staticRenderFns } from "./ProductionResources.vue?vue&type=template&id=4490785a&scoped=true"
import script from "./ProductionResources.vue?vue&type=script&lang=js"
export * from "./ProductionResources.vue?vue&type=script&lang=js"
import style0 from "./ProductionResources.vue?vue&type=style&index=0&id=4490785a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490785a",
  null
  
)

export default component.exports